import { render, staticRenderFns } from "./InboxLabels.vue?vue&type=template&id=6ccdc83a&"
import script from "./InboxLabels.vue?vue&type=script&lang=js&"
export * from "./InboxLabels.vue?vue&type=script&lang=js&"
import style0 from "./InboxLabels.vue?vue&type=style&index=0&id=6ccdc83a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports